// src/features/participants/page/Company

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import { Button, Spin } from 'antd'; // <-- Add Spin here
import type { ColumnsType } from 'antd/es/table';
import { Tooltip } from 'antd';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { CompanyType, PolicyHolderTypeColumns } from '../../types/participantsTypes';
import { RiFileSettingsLine } from 'react-icons/ri';
import CompanyCard from './CompanyCard';
import { useQuery } from '@tanstack/react-query';
import { post } from '../../../../common/services/httpClient';
import { useRouter } from "@tanstack/react-router";
import StatusTag from '../../../../common/components/Status';
import { useTranslation } from 'react-i18next';
import { ACTIVE_INACTIVE_OPTIONS } from '../../../../common/staticData/options';
import dayjs from 'dayjs';
// ----------------- Types -----------------

const Company = () => {
    const { t } = useTranslation();
    const router = useRouter();
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEYS.PARTICIPANTS.COMPANY],
        queryFn: async () => {
            const res = await post<{ data: CompanyType[]; userType: string }>(
                API_ENDPOINTS.PARTICIPANTS.SEARCH_COMPANY,
                {}
            );
            return res;
        },
    });

    // Case 0: Loading state
    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <Spin tip="Loading..." size="large" />
            </div>
        );
    }

    // Case 1: if userType = company then show card
    //if (data?.userType === "company") {
    //    return <CompanyCard company={data.data[0]} />;
    //}

    if (data?.userType === "company") {
        const company = data.data[0];

        return (
            <div>
                <div
                    onClick={() =>
                        router.navigate({
                            to: "/participants/company/Detail",
                            state: { record: company } as Record<string, unknown>,
                        })
                    }
                    style={{ cursor: "pointer" }}
                >
                    <CompanyCard company={company} />
                </div>
                <div style={{ marginTop: 12 }}>
                    <Tooltip title={t('Company Service')}>
                        {/*<Button*/}
                        {/*    icon={<RiFileSettingsLine style={{ fontSize: 16 }} />}*/}
                        {/*    onClick={() =>*/}
                        {/*        router.navigate({*/}
                        {/*            to: '/participants/company/service',*/}
                        {/*            state: { companyId: company.id, companyName: company.name } as Record<string, unknown>,*/}
                        {/*        })*/}
                        {/*    }*/}
                        {/*>*/}
                        {/*    {t('Company Service')}*/}
                        {/*</Button>*/}
                    </Tooltip>
                </div>
            </div>
        );
    }

    const myActions = [
        {
            render: (record: CompanyType) => (
                <Tooltip title={t('Company Service')}>
                    <Button
                    style={{borderRadius: "6px",
                            height: "32px",
                            width: "32px"}}
                            icon={<RiFileSettingsLine style={{ fontSize: 16 }} />}
                        onClick={() =>
                            router.navigate({
                                to: '/participants/company/service',
                                state: { companyId: record.id, companyName: record.name } as Record<string, unknown>,
                            })
                        }
                    />
                </Tooltip>
            ),
        },
    ];

    // Case 2: otherwise default table will render 
    // Define columns for the Company table
    const CompanyColumns: ColumnsType<CompanyType> = [
        {
            title: 'Name',
            key: 'name',
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        router.navigate({
                            to: '/participants/company/Detail', // Corrected path
                            state: { record: record } as Record<string, unknown>,
                        });
                    }}
                >
                    {record.name}
                </Button>
            ),
        },
        { title: "Customer", dataIndex: "customerName", key: "customerName" },
        //{ title: "Name", dataIndex: "name", key: "name", sorter: true },
        { title: "Phone", dataIndex: "phoneNo", key: "phoneNo" },
        // { title: "Mobile", dataIndex: "mobileNo", key: "mobileNo" },
        // { title: "Email", dataIndex: "email", key: "email" },
        //{ title: "Website", dataIndex: "webSite", key: "webSite" },
        { title: "Country", dataIndex: "country", key: "country" },
        { title: "City ", dataIndex: "city", key: "city" },
        //{ title: "Area", dataIndex: "area", key: "area" },
        //{ title: "Street No", dataIndex: "streetNo", key: "streetNo" },
        //{ title: "Address", dataIndex: "address", key: "address" },
        //{ title: "Note", dataIndex: "note", key: "note" },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            fixed: 'right',
            render: (status: boolean) => {
                return <StatusTag status={(status === true) ? "Active" : "Inactive"} />
            },
        },
    ];

    // ----------------- Child Columns -----------------
    const childColumns: ColumnsType<PolicyHolderTypeColumns> = [
        { title: "Card No", dataIndex: "cardNumber", key: "cardNumber" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Plan", dataIndex: "planName", key: "planName" },
        { title: "Group", dataIndex: "groupName", key: "groupName" },
        {
            title: "Effective Date",
            dataIndex: "effectiveDate",
            key: "effectiveDate",
            render: (date: string | null) =>
                date ? dayjs(date).format('DD-MM-YYYY') : "-",
        },
        {
            title: "Expiry Date",
            dataIndex: "expiryDate",
            key: "expiryDate",
            render: (date: string | null) =>
                date ? dayjs(date).format('DD-MM-YYYY') : "-",
        },
        { title: "Mobile", dataIndex: "mobileNo", key: "mobileNo" },
        {
            title: "DOB",
            dataIndex: "dob",
            key: "dob",
            render: (date: string | null) =>
                date ? dayjs(date).format('DD-MM-YYYY') : "-",
        },
        { title: "City", dataIndex: "city", key: "city" },
        { title: "Address", dataIndex: "address", key: "address" },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => (
                <StatusTag status={status} />
            ),
        },
    ];

    // ---------- Expandable Row ----------
    const expandedRowRender = (record: CompanyType) => {
        return (
            <div style={{ margin: "0px 25px" }}>
                <DynamicTable<PolicyHolderTypeColumns>
                    key={record.id}
                    tableTitle={t("Policy Holder(s):") + " " + record.name}
                    //${record.name}
                    dataApiUrl={API_ENDPOINTS.PARTICIPANTS.SEARCH_POLICYHOLDER}
                    baseQueryKey={["CompanyDetailList", String(record.id)]}
                    columns={childColumns}
                    showActions={false}
                    addNewPermission= "false"   
                    initialFilters={{ companyId: record.id }}
                    filterConfigs={[
                        {
                            field: "searchBy", placeholder: "Select option", type: 'select', showSearch: true,

                            options: [
                                { label: 'Name', value: 'Name' },
                                { label: 'Card Number', value: 'CardNumber' },
                                { label: 'Policy Code', value: 'PolicyCode' }
                            ]

                        },
                        { field: "searchValue", placeholder: "Search by policy holder name", type: 'input' },
                        {
                            field: "Print",
                            type: "export",
                            exportOptions: {
                                url: API_ENDPOINTS.PARTICIPANTS.EXPORT_POLICYHOLDER,
                                fileName: "PolicyHolder",
                                fileType: "excel", // "csv" 
                                defaultPayload: { companyId: record.id },
                                columns: [
                                    { header: "Card Number", key: "cardNumber" },
                                    { header: "Name", key: "name" },
                                    { header: "Plan", key: "planName" },
                                    { header: "Group", key: "groupName" },
                                    {
                                        header: "Effective Date",
                                        key: "effectiveDate",
                                        transform: (date: string) => date ? dayjs(date).format('DD-MM-YYYY') : "-"
                                    },
                                    {
                                        header: "Expiry Date",
                                        key: "expiryDate",
                                        transform: (date: string) => date ? dayjs(date).format('DD-MM-YYYY') : "-"
                                    },
                                    { header: "Mobile", key: "mobileNo" },
                                    {
                                        header: "DOB",
                                        key: "dob",
                                        transform: (date: string) => date ? dayjs(date).format('DD-MM-YYYY') : "-",
                                    },
                                    { header: "City", key: "city" },
                                    { header: "Address", key: "address" },
                                    { header: "Status", key: "status" }
                                ]
                            }
                        }
                    ]}
                />
            </div>
        );
    };

    return (
        <div>
            <DynamicTable<CompanyType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.PARTICIPANTS.SEARCH_COMPANY} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.PARTICIPANTS.COMPANY} // Unique query key for menus
                columns={CompanyColumns}
                tableTitle={"Companies"}
                secondButtonTitle={t("Exceptions")}
                secondButtonUrl="/participants/company/exceptions"
                secondButtonPermissionKey={API_ENDPOINTS.EXCEPTIONS.SEARCH}
                deleteBaseUrl={API_ENDPOINTS.PARTICIPANTS.DELETE_COMPANY}
                deletePayloadField={"name"}
                expandable={{
                    expandedRowRender,
                    rowExpandable: (record) => record.id !== undefined,
                }}
                showActions={{
                    
                    delete: (record) => !record.hasPolicy, // Agar active policy hai to delete na dikhaye
                    
                }}
                customActions={myActions}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name",type:'input', placeholder: "Search by company name" },
                    { field: "email", type: 'input', placeholder: "Search by company email" },
                    {
                        field: 'status',
                        type: 'select',
                        placeholder: "Select Status",
                        showSearch: true,
                        options: ACTIVE_INACTIVE_OPTIONS
                    },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.PARTICIPANTS.EXPORT_COMPANY,
                            fileName: "Companies",
                            fileType: "excel", // "csv" 
                            defaultPayload: { },
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Phone", key: "phoneNo" },
                                { header: "Customer", key: "customerName" },
                                // { header: "Email", key: "email" },
                                { header: "Country", key: "country" },
                                { header: "City", key: "city" },
                                { header: "Status", key: "status", transform: (val: boolean) => val === true ? "Active" : "Inactive" }
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default Company;